var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagLibya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.58763 9.04341C0.5705 11.1469 0 13.5067 0 15.9999C0 18.4931 0.5705 20.8529 1.58763 22.9564L16 24.3477L30.4124 22.9564C31.4295 20.8529 32 18.4931 32 15.9999C32 13.5067 31.4295 11.1469 30.4124 9.04341L16 7.6521L1.58763 9.04341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58789 22.9565C4.17577 28.3085 9.65633 32 15.9997 32C22.343 32 27.8236 28.3085 30.4115 22.9565H1.58789Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58789 9.0435H30.4115C27.8236 3.69156 22.343 0 15.9997 0C9.65633 0 4.17577 3.69156 1.58789 9.0435Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7241 13.0742L21.0369 14.8833L23.1629 14.1939L21.8481 16.0014L23.1607 17.8104L21.0354 17.1184L19.7206 18.9259L19.7219 16.6908L17.5966 15.9988L19.7227 15.3095L19.7241 13.0742Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1413 20.5218C13.6441 20.5218 11.6196 18.4973 11.6196 16.0001C11.6196 13.5028 13.6441 11.4783 16.1413 11.4783C16.9199 11.4783 17.6526 11.6752 18.2923 12.0218C17.2888 11.0405 15.9165 10.4348 14.4022 10.4348C11.3286 10.4348 8.83701 12.9264 8.83701 16C8.83701 19.0736 11.3286 21.5652 14.4022 21.5652C15.9166 21.5652 17.2888 20.9595 18.2923 19.9782C17.6526 20.3249 16.92 20.5218 16.1413 20.5218Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagLibya);
export default __webpack_public_path__ + "static/media/flag_libya.5a3950d81f9226ebafb1a6a65fa71f7f.svg";
export { ForwardRef as ReactComponent };